const base_url = process.env.REACT_APP_BASE_URL;

// Login
export async function loginApiCall(formData) {
    const response = await fetch(`${base_url}/api-token-auth/`,{ method: "post", body: formData});
    return response
}